var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "x_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 5215",
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "close",
  clipPath: "url(#x_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13258",
  d: "M19.705 18.247 11.414 10l8.251-8.292A1 1 0 1 0 18.247.295L10 8.586 1.705.334A1 1 0 0 0 .3 1.752L8.585 10 .334 18.294a1 1 0 0 0 1.419 1.411L10 11.414l8.3 8.251a1 1 0 0 0 1.41-1.418",
  fill: "currentColor"
}))));
export default SvgX;